import CryptoJS from 'crypto-js';
import { axiosInstance } from '@/service';

type SignatureCtx = { ip: string; timestamp: number };

let cached: { value: SignatureCtx; at: number } | null = null;

async function getSignatureCtx(): Promise<SignatureCtx> {
    const now = Date.now();
    if (cached && now - cached.at < 45_000) return cached.value;

    const { data } = await axiosInstance.get<SignatureCtx>('auth/member/signature-ip', {
        headers: { doNotAddUserTokenAuthorization: true },
    });

    cached = { value: data, at: now };
    return data;
}

function hmacHex(secretKey: string, canonical: string): string {
    return CryptoJS.HmacSHA256(canonical, secretKey).toString();
}

export async function withZBSignature<T extends { email?: string }>(body: T) {
    const email = (body.email ?? '').trim().toLowerCase();
    if (!email) return body;

    const secretKey = import.meta.env.VITE_ZB_SIGNATURE_KEY as string | undefined;
    if (!secretKey) {
        return body;
    }

    const { ip, timestamp } = await getSignatureCtx();
    const canonical = `${email}|${ip}|${timestamp}`;
    const signature = hmacHex(secretKey, canonical);

    return {
        ...body,
        signature,
        sig_ip: ip,
        sig_timestamp: timestamp,
    };
}